import React from 'react';
import PropTypes from 'prop-types';

const AccessibilityTab = ({ id, selected, onClick, menu, hidden, children, ...params }) => {

    let additionalProps = {
        id: `${id}-tab`,
        'aria-controls': `${id}-panel`,
        'aria-selected': selected,
        tabIndex: selected ? 0 : -1,
        ...params
    };

    if (menu) {
        additionalProps['aria-haspopup'] = "menu";
    } else {
        additionalProps.role = "tab";
    }
    if (onClick) {
        additionalProps.onClick = onClick;
    }

    // Ensure children is wrapped in a React element if it's a string
    const childElement = typeof children === 'string' ? <span>{children}</span> : children;
    
    // should be last:
    if (hidden) {
        additionalProps = { ...params };
        additionalProps.style = { ...additionalProps.style, visibility: 'hidden' }; // Hide children using CSS
    }

    return React.cloneElement(childElement, additionalProps);
};

AccessibilityTab.propTypes = {
    id: PropTypes.string.isRequired,
    selected: PropTypes.bool.isRequired,
    menu: PropTypes.bool,
    hidden: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string,
    ]).isRequired,
};

export default AccessibilityTab;
